export default "__VITE_ASSET__Cn7F1tQB__"